<template>
  <v-card>
    <v-card-text>
      <h2><v-icon>backup</v-icon>Uploads</h2>
      <div>
        <v-btn
          :to="{
            name: 'scanners',
            query: { objectType: 'entity', objectId: $route.params.id }
          }"
        >
          <v-icon>add</v-icon>Scan
        </v-btn>
        <v-btn
          :to="{
            name: 'upload',
            query: { objectType: 'entity', objectId: $route.params.id }
          }"
        >
          <v-icon>add</v-icon>Upload
        </v-btn>
      </div>
      <div v-if="entity.uploadEntities && entity.uploadEntities.length > 0">
        <div
          v-for="(uploadEntity, ueindex) in entity.uploadEntities"
          :key="ueindex"
          :class="ueindex % 2 == 0 ? 'uploadEven' : 'uploadOdd'"
        >
          <div style="float: right">
            <v-btn-toggle>
              <v-btn @click="downloadUploadEntity(uploadEntity)" small>
                <v-icon>picture_as_pdf</v-icon>Download
              </v-btn>
              <v-btn
                :to="{ name: 'uploadEntity', params: { id: uploadEntity.id } }"
                small
              >
                <v-icon>edit</v-icon>Edit
              </v-btn>
              <v-btn
                @click="deleteUploadEntity(uploadEntity)"
                color="error"
                small
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </div>
          <div class="uploadImage">
            <v-img
              :src="require('@/assets/events/cloud.jpg')"
              class="eventLogo"
              alt="Uploads"
            />
          </div>
          <div class="uploadRightPanel">
            <div>
              <strong>Upload</strong>
            </div>
            <div>
              <!-- <h:outputText value="#{uploadEntity.upload.virus}" />
              <h:outputText value="#{uploadEntity.hide}" />-->
              <span>{{ uploadEntity.timestamp | formatDateTime }}</span>
              <span>&#160;</span>
              <EntityZ
                :entity="uploadEntity.user"
                format="system"
                v-if="uploadEntity.user"
              />
            </div>
            <div>
              <span v-if="uploadEntity.uploadDescription">{{
                uploadEntity.uploadDescription.body
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <span v-if="!entity.uploadEntities || entity.uploadEntities.length == 0"
        >No uploads on this entity</span
      >
    </v-card-text>
  </v-card>
</template>

<script>
import UPLOAD_ENTITY_SIGNED_URL from "@/graphql/document/UploadEntitySignedUrl";
import DELETE_ENTITY_UPLOAD_ENTITY from "@/graphql/directory/DeleteEntityUploadEntity";
import EntityZ from "@/components/link/EntityZ";
export default {
  name: "Uploads",
  components: { EntityZ },
  props: ["entity"],
  methods: {
    async deleteUploadEntity(uploadEntity) {
      if (confirm("Are you sure?")) {
        await this.$apollo.mutate({
          mutation: DELETE_ENTITY_UPLOAD_ENTITY,
          variables: {
            id: Number(this.$route.params.id),
            uploadentityid: uploadEntity.id
          }
        });
        // console.log(response.data);
        this.$emit("triggerUpdate");
      }
    },
    async downloadUploadEntity(uploadEntity) {
      const response = await this.$apollo.query({
        query: UPLOAD_ENTITY_SIGNED_URL,
        variables: { id: uploadEntity.id }
      });
      window.open(response.data.uploadEntity.upload.signedUrlGet, "_blank");
    }
  }
};
</script>

<style>
.uploadOdd {
  padding: 5px;
}

.uploadEven {
  background: #eeeeee;
  padding: 5px;
}

.uploadDeletePanel {
  float: left;
}

.uploadImage {
  float: left;
  padding-left: 15px;
}

.uploadRightPanel {
  margin-left: 75px;
}
.eventLogo {
  height: 45px;
  width: 45px;
  border: 1px solid gray;
}
</style>
